import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  mobileRoot: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "14px 20px",
    margin: 14,
    color: theme.palette.text.primary,
    fontSize: 13,
    backgroundColor: "#f7f7f7",
    borderRadius: 4,
    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.10)",
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      fontSize: 12
    }
  },
  mobileInfoRow: {
    display: "grid",
    alignItems: "center",
    gridTemplateColumns:
      "minmax(0, 1fr) minmax(0, 1fr) minmax(112px, 1.35fr) max-content",
    columnGap: 8
  },
  horseName: {
    textTransform: "uppercase",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  mobileCell: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  mobileLine: {
    height: 8,
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#eee"
  },
  mobileLineValue: {
    width: "10%",
    height: "100%",
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main
  },
  highAttention: {
    "&& > div > span": {
      background: theme.palette.error.main
    }
  }
}));
